export enum IresaPaymentModeEnum {
    INTERNET_CARTE_BLEUE = "INTERNET CARTE BLEUE", // NL, FR systempay
    INTERNET_CARTE_VISE = "INTERNET CARTE VISA", // NL, FR systempay
    INTERNET_MASTERCARD = "INTERNET MASTERCARD", // NL, FR systempay
    INTERNET_CARTE_AMEX = "INTERNET CARTE AMEX", // NL, FR systempay
    STRIPE_CREDIT_CARD_UK = "STRIPE CREDIT CARD UK", // STRIPE UK
    STRIPE_CREDIT_CARD_NL = "STRIPE", // STRIPE NL
    IDEAL = "SNOWTIME IDEAL",
    BANCONTACT = "BANCONTACT",
    BANCONTACT_NL = "BANCONTACT",
    ANCV = "CHEQUE VACANCES",
    APPLE_PAY = "APPLE PAY",
    GOOGLE_PAY = "GOOGLE PAY",
}

// Payment modes that can be scheduled by stripe
export const StripeScheduledPaymentModesEnum = [
    IresaPaymentModeEnum.STRIPE_CREDIT_CARD_UK,
    IresaPaymentModeEnum.STRIPE_CREDIT_CARD_NL,
]

// Payment modes that can be scheduled by systempay
export const SystempayScheduledPaymentModesEnum = [
    IresaPaymentModeEnum.INTERNET_CARTE_BLEUE,
    IresaPaymentModeEnum.INTERNET_CARTE_VISE,
    IresaPaymentModeEnum.INTERNET_MASTERCARD,
    IresaPaymentModeEnum.INTERNET_CARTE_AMEX,
]

// Payment modes that can be scheduled by adyen
export const AdyenScheduledPaymentModesEnum = [
    IresaPaymentModeEnum.INTERNET_CARTE_BLEUE,
    IresaPaymentModeEnum.INTERNET_CARTE_VISE,
    IresaPaymentModeEnum.INTERNET_MASTERCARD,
    IresaPaymentModeEnum.INTERNET_CARTE_AMEX,
    IresaPaymentModeEnum.STRIPE_CREDIT_CARD_NL,
    IresaPaymentModeEnum.STRIPE_CREDIT_CARD_UK,
    IresaPaymentModeEnum.APPLE_PAY,
    IresaPaymentModeEnum.GOOGLE_PAY,
]